import { render, staticRenderFns } from "./TitleView.vue?vue&type=template&id=2b71cb65&scoped=true&"
var script = {}
import style0 from "./TitleView.vue?vue&type=style&index=0&id=2b71cb65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71cb65",
  null
  
)

export default component.exports